const localStorageKey = 'csrf-token';

export function getCsrfToken(): string | null {
    return localStorage.getItem(localStorageKey);
}

export function setCsrfToken(csrfToken: string) {
    localStorage.setItem(localStorageKey, csrfToken);
}
